export type CorelysRuntimeConfig = {
	apiBaseUrl?: string;
};

declare global {
	interface Window {
		__CORELYS_CONFIG__?: CorelysRuntimeConfig;
	}
}

function stripTrailingSlash(url: string): string {
	return url.trim().replace(/\/$/, '');
}

/**
 * URL de l'API (sans /v2).
 * En production : lue dans /config.js (window.__CORELYS_CONFIG__.apiBaseUrl),
 * fichier local à chaque instance, absent du build.
 * En développement : repli sur REACT_APP_API_BASE_URL si config.js est absent.
 */
export function getApiBaseUrl(): string {
	const configured = window.__CORELYS_CONFIG__?.apiBaseUrl;
	if (configured && configured.trim() !== '') {
		return stripTrailingSlash(configured);
	}
	if (process.env.NODE_ENV === 'development') {
		return stripTrailingSlash(
			process.env.REACT_APP_API_BASE_URL ?? 'http://localhost:8000/api'
		);
	}
	return '';
}
